export const STAGES = [
  "key_return",
  "checkout_inspection",
  "bag_and_bin",
  "maintenance_inspection",
  "internal_repairs",
  "external_repairs",
  "painting",
  "cleaning",
  "cleaning_inspection",
  "welcome_packs",
  "completed",
];

// Stages that appear in the sidebar navigation
export const NAV_STAGES = [
  ...STAGES.slice(0, STAGES.length - 1), // everything except completed
  "refurbishment",
  "refurbishment_inspection",
  "completed",
];

// Stages exposed in the user-permission picker
export const PERMISSION_STAGES = [...STAGES, "refurbishment", "refurbishment_inspection"];

export const STAGE_COLORS = {
  key_return: { bg: "#F3F4F6", text: "#374151", border: "#D1D5DB" },
  checkout_inspection: { bg: "#EFF6FF", text: "#1D4ED8", border: "#BFDBFE" },
  bag_and_bin: { bg: "#EEF2FF", text: "#4338CA", border: "#C7D2FE" },
  maintenance_inspection: { bg: "#FFFBEB", text: "#B45309", border: "#FDE68A" },
  internal_repairs: { bg: "#FEF2F2", text: "#B91C1C", border: "#FECACA" },
  external_repairs: { bg: "#FEF2F2", text: "#991B1B", border: "#FCA5A5" },
  painting: { bg: "#FFF7ED", text: "#C2410C", border: "#FED7AA" },
  cleaning: { bg: "#F0F9FF", text: "#0369A1", border: "#BAE6FD" },
  cleaning_inspection: { bg: "#E0F2FE", text: "#0284C7", border: "#7DD3FC" },
  welcome_packs: { bg: "#ECFDF5", text: "#047857", border: "#A7F3D0" },
  completed: { bg: "#F0FDF4", text: "#15803D", border: "#BBF7D0" },
  refurbishment: { bg: "#FEF2F2", text: "#B91C1C", border: "#FCA5A5" },
  refurbishment_inspection: { bg: "#FFFBEB", text: "#B45309", border: "#FDE68A" },
  returning_resident: { bg: "#F3E8FF", text: "#6D28D9", border: "#DDD6FE" },
};

export const STAGE_LABELS = {
  key_return: "Not Started",
  checkout_inspection: "Checkout Inspection",
  bag_and_bin: "Bag & Bin",
  maintenance_inspection: "Maintenance Inspection",
  internal_repairs: "Internal Repairs",
  external_repairs: "External Repairs",
  painting: "Painting",
  cleaning: "Cleaning",
  cleaning_inspection: "Cleaning Inspection",
  welcome_packs: "Welcome Packs",
  completed: "Completed",
  refurbishment: "Refurbishment",
  refurbishment_inspection: "Refurb Inspection",
  returning_resident: "Returning Resident",
};

export const KEY_STATUSES = [
  "Room Occupied",
  "No - Returning at a later date",
  "No - Chargeable",
  "No - Not Chargeable",
  "Yes",
];

export const BED_SIZES = ["Single", "Small Double", "Double", "King"];
